import axios from "axios";
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getToken } from "../../../../helpers/Jwt";

const ReadNews = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [error, setError] = useState(null);
    const [detailData, setDetailData] = useState(null);
    const [otherNews, setOtherNews] = useState([]);

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_NEWS = "api/kejati/News";

    const fetchData = async (url, headers) => {
        try {
            const response = await axios.get(url, { headers });
            return response.data;
        } catch (err) {
            setError("Gagal memuat data. Silakan coba lagi.");
            console.error(err);
            return null;
        }
    };

    useEffect(() => {
        if (id) {
            // Fetch detail berita
            fetchData(`${BASE_URL}${PATH_NEWS}/Detail?id=${id}`, {
                Authorization: `Bearer ${getToken()}`,
                "Content-Type": "application/json"
            }).then((detail) => {
                setDetailData(detail);
            });

            // Fetch berita lainnya
            fetchData(`${BASE_URL}${PATH_NEWS}`, {
                Authorization: `Bearer ${getToken()}`,
                "Content-Type": "application/json"
            }).then((data) => {
                const filteredNews = data?.filter((news) => news.id !== id);
                setOtherNews(filteredNews || []);
            });
        }
    }, [id]);

    const statusColor = (status) => {
        switch (status) {
            case 'show':
            case '':
                return 'info';
            case 'hide':
                return 'warning';
            case 'default':
                break;
        }
        return 'default';
    };

    const handleNewsClick = (newsId) => {
        navigate(`/news/${newsId}`);
    };

    if (error) return <p className="text-center text-red-500">Error: {error}</p>;

    return (
        <div className="max-w-7xl mx-auto p-6 flex flex-col lg:flex-row gap-6">
            {/* Bagian utama: Berita detail */}
            <div className="lg:w-3/4 bg-white rounded-lg shadow-md p-6">
                <h1 className="text-3xl font-bold text-gray-800 mb-4">{detailData?.headline}</h1>
                <p className="text-sm text-gray-500 mb-6">
                    <strong>Diterbitkan pada:</strong> {new Date(detailData?.created_at).toLocaleDateString()}
                </p>
                <img
                    src={`${BASE_URL}/upload/${detailData?.image}`}
                    alt={detailData?.headline}
                    className="w-full h-auto rounded-lg shadow-md mb-6"
                />
                <p className="text-lg text-gray-700 leading-relaxed">
                    <div dangerouslySetInnerHTML={{ __html: detailData?.article }} />
                </p>
            </div>

            {/* Sidebar: Berita lainnya */}
            <div className="lg:w-1/4 bg-gray-100 rounded-lg shadow-md p-6">
                <h2 className="text-2xl font-semibold text-gray-800 mb-4">Berita Lainnya</h2>
                <div className="flex flex-col gap-4">
                    {otherNews.map((news) => (
                        <div
                            key={news.id}
                            className="cursor-pointer hover:bg-gray-200 transition rounded-lg p-4 bg-white shadow"                            
                        >
                            <a href={`/activity-kejati/news/detail/${news.id}`} className="h-2 text-xl font-semibold text-gray-800 mb-2">
                                {news.headline}
                            </a>
                            <p className="text-sm text-gray-500">
                                {new Date(news.created_at).toLocaleDateString()}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ReadNews;
